<template>
  <detail-classifications :item="substance" verbose="cette substance"></detail-classifications>
</template>

<script>
import DetailClassifications from '@/components/DetailClassifications'

export default {
  name: 'SubstanceClassifications',
  components: { DetailClassifications },

  props: {
    substance: Object
  }
}
</script>
